import { isPlatformBrowser } from '@angular/common';
import { Component, Renderer2, AfterViewInit, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Plan } from 'src/app/shared/interfaces/MyAccount.interface';
import { ApiServices } from 'src/app/shared/services/api.service';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss']
})
export class FeatureComponent implements OnInit {
  plans: Array<Plan> = [];
  public isLoading = false;
  public isLoggedIn = false;

  constructor(private dataService: DataService, private renderer: Renderer2, private apiService: ApiServices, private router: Router,
    @Inject(PLATFORM_ID) private platformID: any) {

      if (isPlatformBrowser(this.platformID)) {
        const token = localStorage.getItem('ts_vendor_access_token');
        if(token) {
          this.isLoggedIn = true;
        }
        this.dataService.isLoggedIn.asObservable().subscribe(loggeind => {
          this.isLoggedIn = loggeind;
          if (!this.isLoggedIn) {
            const token = localStorage.getItem('ts_vendor_access_token');
            if(token) {
              this.isLoggedIn = true;
            } else {
              this.isLoggedIn = false;
            }
          }
        });
      }
    }

  ngOnInit(): void {
    this.isLoading = true;
    this.apiService.getPlans().subscribe(({data}) => {
      this.isLoading = false;
      this.plans = data.plans;
    }, (err) => {
      this.isLoading = false;
    })
  }

  purchase(plan: Plan) {
    this.router.navigate(['/login'], {queryParams: {plan: plan.slug}});
  }

  ngAfterViewInit() {
    // Add a class to the body element
    //this.renderer.addClass(document.body, 'bg-black');
  }
  ngOnDestroy() {
    // Remove the class from the body element
    //this.renderer.removeClass(document.body, 'bg-black');
  }

  LoginPage(){
    this.router.navigate(['/login?signup=true']);
  }

}
